import { supabase } from "../admin/supabase";

/**
 * Public-facing language list for the front-end switcher — only
 * languages the admin has enabled, ordered the way they should
 * appear in the dropdown.
 */
export async function getEnabledLanguages() {
  const { data, error } = await supabase
    .from("site_languages")
    .select("id, code, name, native_name, flag_code, is_default, display_order")
    .eq("enabled", true)
    .order("display_order", { ascending: true });

  if (error) {
    console.error("Failed to load site languages", error);
    return [];
  }
  return data || [];
}

export function findDefaultLanguage(languages) {
  return languages.find((l) => l.is_default) || languages[0] || null;
}
